import { render } from "./CarBrands.vue?vue&type=template&id=4ec39796&scoped=true"
import script from "./CarBrands.vue?vue&type=script&lang=js"
export * from "./CarBrands.vue?vue&type=script&lang=js"

import "./CarBrands.vue?vue&type=style&index=0&id=4ec39796&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ec39796"

export default script